export abstract class BaseModel {
  id?: number | null;

  [key: string]: any;

  constructor(object?: any) {
    if (object) {
      for (const key of Object.keys(object)) {
        this[key] = object[key];
      }
    }
  }
}
